import React from 'react';
import { Section } from 'shared/ui/Section';
import { Field } from 'shared/ui/Field';
import { useReportSectionStatus } from 'shared/state/sectionStatusContext';
import { useDirectorsSection } from './useDirectorsSection';
import { NumField, useNumberDraft } from 'shared/ui/NumField';

/** The Director NVMe SSD select is deliberately absent (CONF-140 §4.5): hidden by
 *  product decision, assumed 1.9 TB. Do not restore it without a ticket. */
export function DirectorsSection({ id }: { id: string }) {
  const s = useDirectorsSection();
  useReportSectionStatus(id, s.status);
  // CONF-217: the count is a draft until blur or Enter, like the storage sets'
  // node counts (it used to commit on every valid keystroke, CONF-181), so a
  // keystroke never re-runs the pipeline; a clamp shows as the "min N" hint.
  const d = useNumberDraft({ value: s.count, min: s.min, integer: true, onCommit: s.onCommit });
  return (
    <Section.Root id={id} defaultOpen>
      <Section.Bar title="Directors" role="Director nodes (D)" summary={s.summary} />
      <Section.Body>
        <div className="grid gap-4 md:grid-cols-3">
          <Field label="Director Count" htmlFor="field-directorCount" hint={d.hint ?? `Minimum ${s.min}. No maximum.`}>
            <NumField id="field-directorCount" ariaLabel="Director Count" value={d.value} min={s.min}
              onChange={d.onChange} onBlur={d.onBlur} onKeyDown={d.onKeyDown} />
          </Field>
        </div>
      </Section.Body>
    </Section.Root>
  );
}
